import styled from 'styled-components';
import tw from 'tailwind.macro';
import { InfiniteSlider } from './InfiniteSlider';

const Container = styled.div<{ shouldRemoveDuplicates: boolean }>`
  ${tw`flex flex-col md:flex-row overflow-hidden`}
  gap:24px;

  ${({ shouldRemoveDuplicates }) =>
    shouldRemoveDuplicates && tw`overflow-x-auto`}
`;

const Slide = styled.div`
  ${tw`p-medium
    flex justify-center items-center
  `}
  width: 168px;
  height: 64px;

  background: #f5f4ec;
  border-radius: 15px;

  @media (min-width: 768px) {
    width: 264px;
    height: 88px;
    ${tw`p-medium2`}
  }
`;

const Image = styled.img`
  ${tw`h-full max-w-full`}
`;

export type AnimatedCardsProps = {
  images: {
    image: string;
    linkUrl?: string;
    openLinkInNewTab?: boolean;
  }[];
  durationInMS: number;
  reverse?: boolean;
  stop?: boolean;
};

const AnnimatedCards = ({
  durationInMS,
  images,
  reverse,
  stop,
}: AnimatedCardsProps) => {
  const shouldRemoveDuplicates = images.length < 5;

  return (
    <Container shouldRemoveDuplicates={shouldRemoveDuplicates}>
      <InfiniteSlider
        durationInSec={durationInMS}
        removeDuplicates={shouldRemoveDuplicates}
        reverse={reverse}
        stop={stop || shouldRemoveDuplicates}
      >
        {images.map(({ image, linkUrl, openLinkInNewTab }, index) => (
          <Slide
            key={index}
            as={linkUrl ? 'a' : undefined}
            href={linkUrl ?? undefined}
            target={openLinkInNewTab ? '_blank' : undefined}
          >
            <Image alt={`Slide ${index}`} src={image} />
          </Slide>
        ))}
      </InfiniteSlider>
    </Container>
  );
};

export default AnnimatedCards;
